<template>
	<div class="flex flex-col items-center p-4 mx-auto rounded-lg shadow-lg w-80">
		<TheLogo class="p-6" />
		<NuxtLink
			class="px-3 py-4 my-2 text-sm font-semibold text-white uppercase rounded-lg bg-mx-orange hover:bg-mx-orange-muted"
			:to="localePath('/get-fiber')"
		>
			{{ $t('address-checker.hero-button-text') }}
		</NuxtLink>
		<div class="pt-4 pb-2 text-2xl font-semibold capitalize">
			{{ location }}
		</div>
		<p class="px-8 font-semibold text-center text-md text-mx-orange">
			{{ $t('service-areas.area.check-availability') }}
		</p>
	</div>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
defineProps({
	location: {
		type: String,
		required: true
	}
})
</script>
